import React from 'react';

const OutlookExtensionLogo = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="10.75" y="3.75" width="17.5" height="24.5" rx="1.75" fill="#1066B5" />
    <rect
      x="10.75"
      y="3.75"
      width="17.5"
      height="24.5"
      rx="1.75"
      fill="url(#paint0_linear_7572_5349)"
    />
    <rect x="10.75" y="6.375" width="8.75" height="8.75" fill="#32A9E7" />
    <rect x="10.75" y="15.125" width="8.75" height="8.75" fill="#167EB4" />
    <rect x="19.5" y="15.125" width="8.75" height="8.75" fill="#32A9E7" />
    <rect x="19.5" y="6.375" width="8.75" height="8.75" fill="#58D9FD" />
    <mask id="mask0_7572_5349" maskUnits="userSpaceOnUse" x="9" y="14" width="21" height="15">
      <path
        d="M9 14.25H28.25C29.2165 14.25 30 15.0335 30 16V26.5C30 27.4665 29.2165 28.25 28.25 28.25H10.75C9.7835 28.25 9 27.4665 9 26.5V14.25Z"
        fill="url(#paint1_linear_7572_5349)"
      />
    </mask>
    <g mask="url(#mask0_7572_5349)">
      <path d="M30 14.25V17.75H28.25V14.25H30Z" fill="#135298" />
      <path d="M30 28.25V16L8.125 28.25H30Z" fill="url(#paint2_linear_7572_5349)" />
      <path d="M9 28.25V16L30.875 28.25H9Z" fill="url(#paint3_linear_7572_5349)" />
    </g>
    <path
      d="M9 12.5C9 11.0503 10.1753 9.875 11.625 9.875H16.875C18.3247 9.875 19.5 11.0503 19.5 12.5V23C19.5 24.4497 18.3247 25.625 16.875 25.625H9V12.5Z"
      fill="black"
      fillOpacity="0.3"
    />
    <rect
      x="2"
      y="8.125"
      width="15.75"
      height="15.75"
      rx="1.75"
      fill="url(#paint4_linear_7572_5349)"
    />
    <path
      d="M14.25 16.0606V15.9152C14.25 13.3944 12.4363 11.625 9.88884 11.625C7.32753 11.625 5.5 13.4065 5.5 15.9394V16.0848C5.5 18.6056 7.31369 20.375 9.875 20.375C12.4225 20.375 14.25 18.5935 14.25 16.0606ZM12.1871 16.0848C12.1871 17.7573 11.2456 18.7632 9.88884 18.7632C8.53204 18.7632 7.57674 17.733 7.57674 16.0606V15.9152C7.57674 14.2427 8.5182 13.2368 9.875 13.2368C11.218 13.2368 12.1871 14.267 12.1871 15.9394V16.0848Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_7572_5349"
        x1="10.75"
        y1="16"
        x2="28.25"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#064484" />
        <stop offset="1" stopColor="#0F65B5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_7572_5349"
        x1="9"
        y1="25.4231"
        x2="30"
        y2="25.4231"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#1B366F" />
        <stop offset="1" stopColor="#2657B0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_7572_5349"
        x1="30"
        y1="22.125"
        x2="9"
        y2="22.125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#44DCFD" />
        <stop offset="0.453125" stopColor="#259ED0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_7572_5349"
        x1="9"
        y1="22.125"
        x2="30"
        y2="22.125"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#259ED0" />
        <stop offset="1" stopColor="#44DCFD" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_7572_5349"
        x1="2"
        y1="16"
        x2="17.75"
        y2="16"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#064484" />
        <stop offset="1" stopColor="#0F65B5" />
      </linearGradient>
    </defs>
  </svg>
);

export default OutlookExtensionLogo;
